module.exports = __webpack_public_path__ + "static/media/btn_google_light.bd3e4ebf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn_google_light.svg
// module id = 125
// module chunks = 43